// extracted by mini-css-extract-plugin
module.exports = {"featured":"Featured-module--featured--2pNTR","featuredContent":"Featured-module--featuredContent--1r113","logo":"Featured-module--logo--3A1OL"};